import { render } from "./documents-popup.vue?vue&type=template&id=87f02f7c&ts=true"
import script from "./documents-popup.vue?vue&type=script&lang=ts"
export * from "./documents-popup.vue?vue&type=script&lang=ts"

import "./documents-popup.vue?vue&type=style&index=0&id=87f02f7c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__